/* eslint-disable no-param-reassign */
import axios from 'axios';
import store from '../vuex/store';
import { getEnv } from '../environment';

const isBrukerinfoEnabled = (config = {}) =>
  Object.prototype.hasOwnProperty.call(config, 'useBrukerinfo') && !config.useBrukerinfo;

export default function setup() {
  axios.interceptors.request.use(
    async (request) => {
      await store.state.updateToken();

      if (isBrukerinfoEnabled()) {
        request.headers.brukerIdentifikator = store.state.brukerinfo.brukerId;
      } else {
        request.headers.brukerIdentifikator = store.state.representasjoner.currentRepresentation.identifikator;
      }

      // VUE_APP_APPLICATION_ID er en API-key generert i Konga, som legges i header i kall til backenden, slik at backenden kan registrere hvilken tjeneste som kaller den.
      request.headers['o-app-id'] = getEnv('VUE_APP_APPLICATION_ID'); // array access pga. bindestrek i header name
      request.headers.Authorization = `Bearer ${store.state.accessToken}`;

      return request;
    },
    (err) => Promise.reject(err)
  );
}
